import './form.css'
import React, { useState, useEffect } from 'react'
import axios from 'axios'

function Form() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.name.length < 3) {
      setErrorMessage('يجب أن يحتوي الاسم على 3 أحرف على الأقل.');
      setSuccessMessage('');
      return;
    }

    if (formData.phone.length < 10 || formData.phone.length > 13) {
      setErrorMessage('يجب أن يحتوي رقم الجوال على بين 10 و 13 رقماً.');
      setSuccessMessage('');
      return;
    }

    const formUrl = 'https://formspree.io/f/mkggpznz'; // استبدل 'your-form-id' بالمعرف الخاص بك على Formspree

    axios.post(formUrl, formData)
      .then(response => {
        console.log('Form submitted successfully:', response);
        setSuccessMessage('تم إرسال النموذج بنجاح.');
        setErrorMessage('');
        setFormData({ name: '', phone: '', message: '' }); // إعادة تعيين الحقول بعد الإرسال الناجح
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        setErrorMessage('حدث خطأ أثناء إرسال النموذج. حاول مرة أخرى.');
        setSuccessMessage('');
      });
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  return (
    <div className='form'>
      <div className="row">
        <div className="mt-3 px-2">
          <div className="form-box">
            <h3>إرسل طلبك:</h3>
            <form onSubmit={handleSubmit}>
              <div className='mb-3'>
                <label>إسم الكريم :</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className='mb-3'>
                <label> رقم الجوال :</label>
                <input type="number" name="phone" value={formData.phone} onChange={handleChange} required min={8}/>
              </div>
              <div className='mb'>
                <label>إكتب طلبك:</label>
                <textarea name="message" value={formData.message} onChange={handleChange} rows='3' required></textarea>
              </div>
              <div className='mb'>
                <button className='cta-button formbtn' type="submit">إرسال</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successMessage && <div className="notification success">{successMessage}</div>}
      {errorMessage && <div className="notification error">{errorMessage}</div>}
    </div>
  );
}

export default Form;
